/* eslint-disable */

import React from 'react'
import { getLinkPreview } from 'link-preview-js'
import {
  ActivityIndicator,
  Dimensions,
  Image,
  ImageStyle,
  Linking,
  Modal,
  Platform,
  StyleSheet,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native'
import { color } from '../../theme/color'
import { Text } from '../text'
import { Header } from '../header'
import { iconClose, iconShare } from '../../assets/icons'
// import WebView from 'react-native-webview'

export class LinkPreview extends React.PureComponent {
  constructor(props: {
    onLoad?: any
    onError?: any
    text: string
    containerStyle?: ViewStyle
    imageStyle?: ImageStyle
    faviconStyle?: ImageStyle
    textContainerStyle?: TextStyle
    title?: boolean
    description?: boolean
    titleStyle?: TextStyle
    titleNumberOfLines?: number
    descriptionStyle?: TextStyle
    descriptionNumberOfLines?: number
    requestOptions?: any
    showTitle?: boolean
  }) {
    super(props)
    this.state = {
      isUri: false,
      url: '',
      showUrl: false,
      linkTitle: undefined,
      linkDesc: undefined,
      linkFavicon: undefined,
      linkImg: undefined,
      siteName: '',
    }
    this.getPreview(props.text, props.requestOptions)
  }

  getPreview = (text: any, options: any) => {
    const { onError, onLoad } = this.props as any
    getLinkPreview(text, options)
      .then((data: any) => {
        onLoad(data)
        this.setState({
          url: data.url,
          siteName: data.siteName,
          isUri: true,
          // @ts-ignore
          linkTitle: data.title ? data.title : undefined,
          // @ts-ignore
          linkDesc: data.description ? data.description : undefined,
          linkImg:
            // @ts-ignore
            data.images && data.images.length > 0
              ? // @ts-ignore
                data.images.find(function(element) {
                  return (
                    element.includes('.png') ||
                    element.includes('.jpg') ||
                    element.includes('.jpeg')
                  )
                })
              : undefined,
          linkFavicon:
            data.favicons && data.favicons.length > 0
              ? data.favicons[data.favicons.length - 1]
              : undefined,
        })
      })
      .catch(error => {
        onError(error)
        this.setState({ isUri: false })
      })
  }

  _onLinkPressed = () => {
    // @ts-ignore
    this.setState({ showUrl: true })
    // Linking.openURL(this.props.text.match(REGEX)[0])
  }

  // @ts-ignore
  renderImage = (imageLink, faviconLink, imageStyle, faviconStyle, imageProps) => {
    if (imageLink) {
      // @ts-ignore
      return (
        <Image
          style={{ height: 220 }}
          source={{ uri: imageLink }}
          // {...imageProps}
        />
      )
    }
    if (faviconLink) {
      return <Image style={faviconStyle} source={{ uri: faviconLink }} {...imageProps} />
    }

    return null
  }

  renderText = (
    showTitle: boolean,
    showDescription: boolean,
    title: string,
    description: string,
    textContainerStyle: ViewStyle,
    titleStyle: TextStyle,
    descriptionStyle: TextStyle,
    titleNumberOfLines: number,
    descriptionNumberOfLines: number,
  ) => {
    return (
      <View
        style={{
          flexDirection: 'column',
          alignSelf: 'flex-start',
          paddingHorizontal: 20,
          paddingVertical: 16,
        }}
      >
        {showTitle && (
          <Text
            numberOfLines={titleNumberOfLines}
            style={{
              fontFamily: 'Inter-SemiBold',
              fontWeight: '600',
              fontSize: 14,
              lineHeight: 18,
            }}
          >
            {title}
          </Text>
        )}
        {showDescription && (
          <Text
            numberOfLines={descriptionNumberOfLines}
            style={{
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: 14,
              lineHeight: 17,
              color: color.shade50,
            }}
            // @ts-ignore
            text={this.state.siteName}
          />
        )}
      </View>
    )
  }

  renderLinkPreview = (
    containerStyle: any,
    imageLink: any,
    faviconLink: any,
    imageStyle: any,
    faviconStyle: any,
    showTitle: boolean,
    showDescription: boolean,
    title: any,
    description: any,
    textContainerStyle: any,
    titleStyle: any,
    descriptionStyle: any,
    titleNumberOfLines: any,
    descriptionNumberOfLines: any,
    imageProps: any,
  ) => {
    return (
      <>
        <TouchableOpacity
          style={{ flexDirection: 'column', width: '100%', backgroundColor: '#F6F8FB' }}
          activeOpacity={0.9}
          onPress={() => this._onLinkPressed()}
        >
          {this.renderImage(imageLink, faviconLink, imageStyle, faviconStyle, imageProps)}
          {this.renderText(
            showTitle,
            showDescription,
            title,
            description,
            textContainerStyle,
            titleStyle,
            descriptionStyle,
            titleNumberOfLines,
            descriptionNumberOfLines,
          )}
        </TouchableOpacity>
        <Modal
          hardwareAccelerated
          presentationStyle="pageSheet"
          animationType="slide"
          // transparent={true}
          // @ts-ignore
          visible={this.state.showUrl}
        >
          <View style={styles.modalView}>
            <View style={styles.modalContainer}>
              <Header
                style={{
                  borderTopRightRadius: 20,
                  borderBottomColor: color.grey,
                  borderBottomWidth: 1,
                  borderTopLeftRadius: 20,
                  marginTop: Platform.OS === 'android' ? 40 : 20,
                  marginBottom: 0,
                }}
                rightIcon={iconClose}
                leftIcon={iconShare}
                onRightPress={() => this.setState({ showUrl: false })}
                // @ts-ignore
                onLeftPress={() => Linking.openURL(this.state.url)}
              />
              {/* <WebView
                startInLoadingState
                renderLoading={() => (
                  <ActivityIndicator
                    color="#999"
                    size="small"
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      flex: 1,
                      justifyContent: 'center',
                      bottom: 40,
                    }}
                  />
                )}
                style={{ flex: 1, borderTopRightRadius: 20, borderTopLeftRadius: 20 }}
                //@ts-ignore
                source={{ uri: this.state.url }}
              /> */}
            </View>
          </View>
        </Modal>
      </>
    )
  }

  render() {
    const {
      text,
      containerStyle,
      imageStyle,
      faviconStyle,
      textContainerStyle,
      title,
      description,
      titleStyle,
      titleNumberOfLines,
      descriptionStyle,
      descriptionNumberOfLines,
      imageProps,
    } = this.props as any

    // @ts-ignore
    return this.state.isUri
      ? this.renderLinkPreview(
          containerStyle,
          // @ts-ignore
          this.state.linkImg,
          // @ts-ignore
          this.state.linkFavicon,
          imageStyle,
          faviconStyle,
          title,
          description,
          // @ts-ignore
          this.state.linkTitle,
          // @ts-ignore
          this.state.linkDesc,
          textContainerStyle,
          titleStyle,
          descriptionStyle,
          titleNumberOfLines,
          descriptionNumberOfLines,
          imageProps,
        )
      : null
  }
}

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'flex-end',
    width: '100%',
    height: Dimensions.get('screen').height,
  },
  modalContainer: {
    backgroundColor: 'white',
    width: '100%',
    height: Dimensions.get('screen').height - 40,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
  },
  modalView: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.9,
    shadowRadius: 12,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  buttonOpen: {
    backgroundColor: '#F194FF',
  },
  buttonClose: {
    backgroundColor: '#2196F3',
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },
})

//@ts-ignore
LinkPreview.defaultProps = {
  onLoad: () => {},
  onError: () => {},
  text: null,
  requestOptions: {},
  containerStyle: {
    backgroundColor: 'rgba(239, 239, 244,0.62)',
    // alignItems: 'center',
    flexDirection: 'column',
  },
  imageStyle: {
    height: 200,
    // paddingRight: 10,
    // paddingLeft: 10,
  },
  faviconStyle: {
    width: 40,
    height: 40,
    paddingRight: 10,
    paddingLeft: 10,
  },
  textContainerStyle: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 10,
  },
  title: 'TitleDefault',
  description: true,
  titleStyle: {
    fontSize: 17,
    fontFamily: 'Inter',
    fontWeight: '700',
    color: '#000',
    marginRight: 10,
    marginBottom: 5,
    alignSelf: 'flex-start',
  },
  titleNumberOfLines: 2,
  descriptionStyle: {
    fontSize: 14,
    color: '#81848A',
    marginRight: 10,
    alignSelf: 'flex-start',
  },
  //@ts-ignore
  descriptionNumberOfLines: Platform.isPad ? 4 : 3,
  imageProps: { resizeMode: 'contain' },
}

// LinkPreview.propTypes = {
//   onLoad: PropTypes.func,
//   onError: PropTypes.func,
//   text: PropTypes.string,
//   containerStyle: ViewPropTypes.style,
//   imageStyle: ViewPropTypes.style,
//   faviconStyle: ViewPropTypes.style,
//   textContainerStyle: ViewPropTypes.style,
//   title: PropTypes.bool,
//   description: PropTypes.bool,
//   titleStyle: Text.propTypes.style,
//   titleNumberOfLines: Text.propTypes.numberOfLines,
//   descriptionStyle: Text.propTypes.style,
//   descriptionNumberOfLines: Text.propTypes.numberOfLines,
//   requestOptions: PropTypes.shape({
//     headers: PropTypes.objectOf(PropTypes.string),
//     imagesPropertyType: PropTypes.string,
//     proxyUrl: PropTypes.string,
//   }),
// }
